// eslint-disable-next-line @nx/enforce-module-boundaries
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { NavItem } from './types';

type SubNavItem = NavItem['subNavItems'][number] & {
  parentPath: string;
};

type ParentNavData = {
  label: string;
  root: string;
  subNavItems: SubNavItem[];
  settings?: {
    label: string;
    path: string;
    show?: boolean;
    disabledReason?: string;
  };
};

export interface SubNavStore {
  parentNavData: Record<string, ParentNavData>;
  registerParentNav: (parentPath: string, data: ParentNavData) => void;
  unregisterParentNav: (parentPath: string) => void;
  getParentNavData: (parentPath: string) => ParentNavData | undefined;
}

export const useSubNavStore = create<SubNavStore>()(
  immer((set, get) => ({
    parentNavData: {},

    registerParentNav: (parentPath, data) => {
      set((state) => {
        state.parentNavData[parentPath] = data;
      });
    },

    unregisterParentNav: (parentPath) => {
      set((state) => {
        delete state.parentNavData[parentPath];
      });
    },

    getParentNavData: (parentPath) => {
      return get().parentNavData[parentPath];
    },
  }))
);
